/* eslint-disable no-console */
import React, { ReactNode } from 'react';
import { AppointmentType } from '../../types/AppointmentType';
import { CustomAppointmentType } from '../../types/CustomAppointmentType';
import { FreeSlot } from '../../types/FreeSlot';
import { PersonalInformation } from '../../types/PersonalInformation';
import { PostAppointmentResponse } from '../../types/PostAppointmentResponse';
import { Store } from '../../types/Store';
import { WizardStep } from '../../types/Wizard';
import WizardContext from './WizardContext';

const WizardProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [step, setStep] = React.useState<WizardStep>(1);
  const [appointmentType, setAppointmentType] = React.useState<AppointmentType | null>(null);
  const [appointmentTypeName, setAppointmentTypeName] = React.useState<string | null>(null);
  const [customAppointmentType, setCustomAppointmentType] = React.useState<CustomAppointmentType | null>(null);
  const [forSomeoneElse, setForSomeoneElse] = React.useState<boolean>(false);
  const [selfRating, setSelfRating] = React.useState<number | null>(null);
  const [storeSlot, setStoreSlot] = React.useState<FreeSlot | null>(null);
  const [store, setStore] = React.useState<Partial<Store> | null>(null);
  const [personalInformation, setPersonalInformation] = React.useState<PersonalInformation | null>(null);
  const [postAppointmentResponse, setPostAppointmentResponse] = React.useState<PostAppointmentResponse | null>(null);
  const [promotions, setPromotions] = React.useState<boolean>(false);

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [step]);

  return (
    <WizardContext.Provider
      value={{
        appointmentType,
        appointmentTypeName,
        customAppointmentType,
        forSomeoneElse,
        personalInformation,
        postAppointmentResponse,
        promotions,
        selfRating,
        setAppointmentType,
        setAppointmentTypeName,
        setCustomAppointmentType,
        setForSomeoneElse,
        setPersonalInformation,
        setPostAppointmentResponse,
        setPromotions,
        setSelfRating,
        setStep,
        setStore,
        setStoreSlot,
        step,
        store,
        storeSlot,
      }}
    >
      {children}
    </WizardContext.Provider>
  );
};

WizardProvider.displayName = 'WizardProvider';

export default WizardProvider;
